import { Component } from "react";
import type { IntlShape } from "react-intl";
import { Checkbox } from "../../../../../../../../../components/Checkbox/Checkbox";
import { IconClose } from "../../../../../../../../../components/Icon/Icon";
type Props = {
  selectAll: boolean;
  toggleAllComps: (...args: Array<any>) => any;
  hideComponent: (...args: Array<any>) => any;
  intl: IntlShape;
};

class CompetitionsHeader extends Component<Props> {
  render() {
    const { toggleAllComps, hideComponent, intl, selectAll } = this.props;
    return (
      <div className="select-competitions__header">
        <div className="select-competitions__header__left">
          <span>
            {intl.formatMessage({
              id: "global-events-navigation-select-leagues",
            })}
          </span>
        </div>
        <div className="select-competitions__header__right">
          <Checkbox checked={selectAll} onChange={toggleAllComps} />
          <span className="select-competitions__header__right">
            {intl.formatMessage({
              id: "global-events-navigation-select-all",
            })}
          </span>
          <div
            className="select-competitions__header__close"
            onClick={hideComponent}
          >
            <IconClose />
          </div>
        </div>
      </div>
    );
  }
}

export default CompetitionsHeader;
